/* eslint-disable no-bitwise */

import { PersonRequest } from "@plinknz/tah-website-elements";

import { CreateSurveyConfig } from "../../components/content-blocks/forms/benefit-form";
import { CustomerFormQuestionTypes } from "../../components/content-blocks/forms/customer-form-types";
import {
  ADDRESS_FINDER_KEY,
  BANK_ACCOUNT_KEY,
  DATEPICKER_KEY,
} from "../../components/survey-widgets/keys";

export function questionTypes(
  createSurveyConfig: CreateSurveyConfig
): CustomerFormQuestionTypes {
  const mockMember = ({
    id: "1",
    firstName: "Tuatahi",
    surname: "Whānau",
    email: [],
    phone: [],
    emailSurrogate: [],
  } as unknown) as PersonRequest;
  const { pages } = createSurveyConfig(mockMember);

  const hasAddress = !!pages.find((p) => {
    return p.questions?.find((q) => q.type === ADDRESS_FINDER_KEY);
  });

  const hasBankAccount = !!pages.find((p) => {
    return p.questions?.find((q) => q.type === BANK_ACCOUNT_KEY);
  });

  const hasDatePicker = !!pages.find((p) => {
    return p.questions?.find((q) => q.type === DATEPICKER_KEY);
  });

  let dynamicQuestionTypes = CustomerFormQuestionTypes.FileUpload;

  if (hasAddress) {
    dynamicQuestionTypes |= CustomerFormQuestionTypes.AddressFinder;
  }

  if (hasBankAccount) {
    dynamicQuestionTypes |= CustomerFormQuestionTypes.BankAccount;
  }

  if (hasDatePicker) {
    dynamicQuestionTypes |= CustomerFormQuestionTypes.DatePicker;
  }

  return dynamicQuestionTypes;
}
